// client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { setupGlobalErrorHandler } from './services/errorReporter';

// ============================================================
// ✅ تفعيل مصائد الأخطاء العالمية (التقاط الأخطاء غير المتوقعة)
// ============================================================
setupGlobalErrorHandler();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ========== تسجيل Service Worker الخاص بـ Firebase ==========
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
        //console.log('✅ Firebase Service Worker registered successfully:', registration);
      })
      .catch((err) => {
        console.error('❌ Firebase Service Worker registration failed:', err);
      });
  });
}